import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const OrderVoidedBadge = (props: BadgeProps): React.ReactElement => (
  <Badge
    {...props}
    icon="CLOSE"
    className={twMerge("bg-zinc-100 text-zinc-700", props.className)}
  >
    Order voided
  </Badge>
);
